module.exports = __webpack_public_path__ + "static/chloe-8f9a8ed14f53c7c70fd9a89bb2c4a11f.jpg";